/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-this-in-sfc */
/* eslint-disable no-shadow */
import React, { useState, useEffect, useRef, useCallback, useLayoutEffect } from 'react'
import { message, Radio } from 'antd'
import classNames from 'classnames'
import { useParams } from 'react-router-dom'
import util from 'meinian-package/src/utils/util'
import Sortable from '@shopify/draggable/lib/es5/sortable'
import SampleModal from 'component/imageDetail/sampleModal'
import Modal from 'meinian-package/src/baseComponent/modal'
import ModalConfirm from 'meinian-package/src/component/modal/modalConfirm'
import Input from 'meinian-package/src/baseComponent/input'
import Upload from 'meinian-package/src/component/upload/image'
import { getIpadVh } from 'common/ipad'
import Icon from 'meinian-package/src/component/icon'
import Textarea from 'meinian-package/src/component/textarea'
import mes from 'meinian-package/src/utils/message'
import request from 'meinian-package/src/utils/request'
import { Loading } from 'meinian-package/src/baseComponent'
import Button from 'meinian-package/src/baseComponent/button'
import userInfo, { getTeamInfo } from 'meinian-package/src/common/userInfo'
import { StyleSelect, MnInputNum, MultipleSelect } from 'meinian-package/src/component/imageDetail/styleSelect'
import TagList from 'meinian-package/src/component/imageDetail/tagSelection'
import { AttrFactory } from 'meinian-package/src/component/imageDetail/attrFactory'
import { GENDER_OPTIONS } from 'meinian-package/src/component/enum'
import { ossImg } from 'meinian-package/src/utils/image'
import { STYLE_PLAN, STYLE_PLAN_TEXT, STYLE_TYPE, STYLE_TYPE_TEXT } from 'common/config/enum'
import { sampleSizeData } from '../filter/sampleFilterOptions'
import UserDefinedProps from '../imageDetail/userDefinedProps'
import './index.less'

const DESIGN_TITLE = [
  {
    index: 0,
    title: '样衣图库',
    id: '#sample'
  },
  {
    index: 1,
    title: '样衣信息',
    id: '#sample-info'
  },
  {
    index: 2,
    title: '协作成员',
    id: '#collaboration'
  },
  {
    index: 3,
    title: '款式特征',
    id: '#sample-trait'
  },
  {
    index: 4,
    title: '样衣属性',
    id: '#sample-attribute'
  },
  {
    index: 5,
    title: '关联信息',
    id: '#sample-associated'
  }
]

const Title = (props) => {
  const { setVisible, isNew } = props
  return <div className="edit-sample-title">
    <Icon type="m-jiantou_zuo" onClick={() => { setVisible(false) }} />
    <span style={{ marginLeft: 16 }}>{isNew ? '新建样衣' : '编辑样衣'}</span>
  </div>
}
export default (props) => {
  const { folderId } = useParams()
  const { visible, setVisible, data = {}, isHome, propIndex = 0, onChange } = props
  const accountInfo = userInfo
  const teamInfo = getTeamInfo()
  const [params, setParams] = useState(data)
  const [imgUrlList, setimgUrlList] = useState([])
  const [sortValue, setSortValue] = useState({})
  const [isNew, setIsNew] = useState(true)
  const [colorList, setColorList] = useState([])
  const [industryAtrr, setIndustryAtrr] = useState([])
  const [switchGender, setSwitchGender] = useState(false)
  const [industryLoading, setindustryLoading] = useState(true)
  const [warn, setWarn] = useState(false)
  const [designerList, setDesignerList] = useState([])
  const [propertyValueParamList, setPropertyValueParamList] = useState([])
  const [homeParams, setHomeParams] = useState([])
  const [titleIndex, setTitleIndex] = useState(propIndex)

  const [sampleVisible, setSampleVisible] = useState(false)

  const $sortWrapper = useRef()
  const $screenWrapper = useRef()
  // 用于页面尺寸变化
  const $titleContent = useRef()
  const $designContent = useRef()
  // 用于页面滑动
  const $container = useRef()
  const $sample = useRef()
  const $sampleInfo = useRef()
  const $collaboration = useRef()
  const $sampleTrait = useRef()
  const $sampleAttribute = useRef()
  const $sampleAssociated = useRef()

  let sampleInfoTop = $sampleInfo.current?.offsetTop
  let collaborationTop = $collaboration.current?.offsetTop
  let sampleTraitTop = $sampleTrait.current?.offsetTop
  let sampleAttributeTop = $sampleAttribute.current?.offsetTop
  let sampleAssociatedTop = $sampleAssociated.current?.offsetTop

  const handScroll = useCallback((e) => {
    sampleInfoTop = $sampleInfo.current?.offsetTop
    collaborationTop = $collaboration.current?.offsetTop
    sampleTraitTop = $sampleTrait.current?.offsetTop
    sampleAttributeTop = $sampleAttribute.current?.offsetTop
    sampleAssociatedTop = $sampleAssociated.current?.offsetTop
    if (e.target.scrollTop < sampleInfoTop) {
      setTitleIndex(0)
    } else if (e.target.scrollTop < collaborationTop) {
      setTitleIndex(1)
    } else if (e.target.scrollTop < sampleTraitTop) {
      setTitleIndex(2)
    } else if (e.target.scrollTop < sampleAttributeTop) {
      setTitleIndex(3)
    } else if (e.target.scrollTop < sampleAssociatedTop) {
      setTitleIndex(4)
    }
  })

  useEffect(() => {
    $container.current?.addEventListener('scroll', handScroll)
    return () => $container.current?.removeEventListener('scroll', handScroll)
  }, [handScroll])

  useEffect(() => {
    sort()
    fetchUsers()
    if (isHome) {
      fetchData(data.id)
    }
  }, [])

  useLayoutEffect(() => {
    setTimeout(() => {
      if (propIndex === 1) {
        document.getElementById('sample-info').scrollIntoView()
      }
      if (propIndex === 2) {
        document.getElementById('collaboration').scrollIntoView()
      }
      if (propIndex === 3) {
        document.getElementById('sample-trait').scrollIntoView()
      }
      if (propIndex === 4) {
        document.getElementById('sample-attribute').scrollIntoView()
      }
    }, 300)
  }, [])

  const handResize = useCallback((e) => {
    $titleContent.current.style.left = `${(e.target.innerWidth - 890) / 2}px`
    $designContent.current.style.right = `${(e.target.innerWidth - 890) / 2}px`
  })

  useEffect(() => {
    window.addEventListener('resize', handResize)
    return () => window.removeEventListener('resize', handResize)
  }, [])

  const fetchUsers = async () => {
    try {
      const res = await request.get('/zhikuan/ins/inspiration/user-selector')
      setDesignerList(res)
    } catch (err) {
      console.error(err)
    }
  }
  useEffect(() => {
    if (Object.keys(data)?.length) {
      setParams(data)
      setimgUrlList(data.imgUrlList)
      if (data.color) {
        try {
          setColorList(JSON.parse(data.color))
        } catch (error) {
          colorList.push(data.color)
          setColorList(colorList)
        }
      }
      setIsNew(false)
    }
  }, [])

  useEffect(() => {
    if (!sortValue.token) return
    const item = imgUrlList.splice(sortValue.oldIndex, 1)
    imgUrlList.splice(sortValue.newIndex, 0, ...item)
    setimgUrlList([...imgUrlList])
  }, [sortValue.token])

  useEffect(() => {
    if (params.gender) {
      fetchIndustryAtrr(params.gender)
    }
    const sub = () => {
      if (params.gender) {
        fetchIndustryAtrr(params.gender)
      }
    }
    mes.sub('MNDefinedProperty', sub)
    return () => { mes.remove('MNDefinedProperty', sub) }
  }, [params.gender])

  useEffect(() => {
    if (!switchGender && industryAtrr.length > 0) {
      if (data?.propertyValueDOList?.length > 0) {
        switchData(industryAtrr, data?.propertyValueDOList)
      } else if (isHome && homeParams?.length > 0) {
        switchData(industryAtrr, homeParams)
      } else if (propertyValueParamList?.length > 0) {
        const convertIndustry = convertData(industryAtrr)
        const mergeParamList = mergeData(convertIndustry, propertyValueParamList)
        setPropertyValueParamList(mergeParamList)
      } else {
        setPropertyValueParamList(convertData(industryAtrr))
      }
    }
    if (switchGender) {
      const convertIndustry = convertData(industryAtrr)
      if (propertyValueParamList?.length > 0) {
        const mergeParamList = mergeData(convertIndustry, propertyValueParamList)
        setPropertyValueParamList(mergeParamList)
      } else {
        setPropertyValueParamList(convertIndustry)
      }
    }
  }, [industryAtrr, data?.propertyValueDOList, homeParams])

  const switchData = (industryAtrr, data) => {
    const convertIndustry = convertData(industryAtrr)
    const newIndustry = mergeData(convertIndustry, data)
    // 有参数，且参数的values有值才去合并
    if (propertyValueParamList?.length > 0 && propertyValueParamList.every(item => item.values?.length != 0)) {
      const mergeParamList = mergeData(newIndustry, propertyValueParamList)
      setPropertyValueParamList(mergeParamList)
    } else {
      setPropertyValueParamList(newIndustry)
    }
  }

  const mergeData = (generalList, pointsList) => {
    for (let i = 0; i < generalList.length; i++) {
      for (let j = 0; j < pointsList.length; j++) {
        if (generalList[i].propertyId == pointsList[j].propertyId) {
          generalList[i] = pointsList[j]
        }
      }
    }
    return generalList
  }

  const fetchData = async (id) => {
    try {
      const res = await request.get('/zhikuan/mn/sample/query-sample-detail', { params: { sampleId: id } })
      if (res.imgUrlList.length > 0) {
        setHomeParams(res.propertyValueDOList)
      }
    } catch (err) {
      console.error(err)
    }
  }

  const fetchIndustryAtrr = async (gender) => {
    setindustryLoading(true)
    try {
      const res = await request.get(`/zhikuan/mn/property/list?targetType=2&gender=${gender}`)
      setIndustryAtrr(res)
    } catch (err) {
      console.error(err)
    }
    setindustryLoading(false)
  }

  const convertData = (data) => {
    if (data?.length > 0) {
      const visibleData = data.filter(item => item.isVisible)
      return visibleData.map((item) => {
        return {
          propertyId: item.propertyId,
          propertyName: item.propertyName,
          propertyType: item.propertyType,
          values: []
        }
      })
    }
    return []
  }
  const onColorsChange = (value) => {
    setColorList(value)
  }
  const onGenderChange = (value) => {
    if (params.gender && value != params.gender) {
      ModalConfirm.show({
        title: '确认更换行业？',
        content: '更换行业后将清空现有款式属性',
        onOk: () => {
          setParams({ ...params, gender: value })
          setSwitchGender(true)
          // setPropertyValueParamList([])
        } })
    } else {
      setParams({ ...params, gender: value })
    }
  }
  const onTitleChange = (index) => {
    if (index == 0) {
      $container.current.scrollTop = 0
    }
    if (index == 1) {
      $container.current.scrollTop = sampleInfoTop
    }
    if (index == 2) {
      $container.current.scrollTop = collaborationTop
    }
    if (index == 3) {
      $container.current.scrollTop = sampleTraitTop
    }
    if (index == 4) {
      $container.current.scrollTop = sampleAttributeTop
    }
    if (index == 5) {
      $container.current.scrollTop = sampleAssociatedTop
    }
    setTitleIndex(index)
  }
  const events = {
    onChangeMainImg(images, image, e) {
      e.stopPropagation()
      const newImages = images.filter(m => m.mainUrl !== image.mainUrl)
      newImages.unshift(image)
      setimgUrlList(newImages)
    },
    dealAttr(attrVal) {
      if (attrVal instanceof Array) {
        return [...attrVal]
      }
      if (attrVal instanceof Set) {
        return Array.from(attrVal)
      }
      if (attrVal == null || attrVal == undefined || attrVal == 'null') {
        return []
      }
      return [attrVal]
    },
    onChangePropertyValue(id, attrVal, type, name) {
      if (propertyValueParamList.findIndex(m => m.propertyId === id) >= 0) {
        const newPropertyValueParamList = propertyValueParamList.filter(item => item.propertyId != id)
        newPropertyValueParamList.push({ propertyId: id, values: this.dealAttr(attrVal), propertyType: type, propertyName: name })
        setPropertyValueParamList([...newPropertyValueParamList])
      } else {
        propertyValueParamList.push({ propertyId: id, values: this.dealAttr(attrVal), propertyType: type, propertyName: name })
        setPropertyValueParamList([...propertyValueParamList])
      }
    },
  }

  const onOk = async () => {
    if (imgUrlList.length < 1) {
      return message.warning('样衣图片不能为空')
    }
    if (!params.name) {
      return message.warning('样衣名称不能为空')
    }
    const urlReg = /(^(ht|f)tps?:)\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/g
    if (params.relatedInspirationUrl && !params.relatedInspirationUrl.match(urlReg)) {
      return message.warning('请输入正确关联款式链接')
    }
    // 提交时将文本标签存本地
    const localColorList = JSON.parse(window.localStorage.getItem('mnEditSampleColorsValue'))
    let coverColorList
    if (localColorList?.length > 0) {
      coverColorList = new Set([...colorList].concat(localColorList))
    } else {
      coverColorList = colorList
    }
    window.localStorage.setItem('mnEditSampleColorsValue', JSON.stringify(Array.from(coverColorList)))
    if (propertyValueParamList?.length > 0) {
      const hyperlinks = propertyValueParamList.filter(m => m.propertyType === 4)
      if (hyperlinks?.length > 0) {
        for (let i = 0; i < hyperlinks.length; i++) {
          if (hyperlinks[i].values != '' && !/^http[s]*:\/\//.test(hyperlinks[i].values)) {
            return message.error('请输入正确的链接')
          }
        }
      }
      // 读取之前存储的params信息
      const result = window.localStorage.getItem('mnEditSampleParams')
      const newLocalParams = propertyValueParamList.filter(m => m.propertyType === 1 || m.propertyType === 2)
      const localParams = JSON.parse(JSON.stringify(newLocalParams))
      if (result) {
        const convertResult = JSON.parse(result)
        if (convertResult?.length > 0) {
          for (let i = 0; i < localParams.length; i++) {
            for (let j = 0; j < convertResult.length; j++) {
              if (convertResult[j].propertyId === localParams[i].propertyId) {
                localParams[i].values = Array.from(new Set(convertResult[j].values.concat(localParams[i].values)))
              }
            }
          }
        }
        window.localStorage.setItem('mnEditSampleParams', JSON.stringify(localParams))
      } else {
        window.localStorage.setItem('mnEditSampleParams', JSON.stringify(localParams))
      }
    }
    if (isNew) {
      setSampleVisible(true)
    } else {
      const editParams = {
        ...params,
        color: [...colorList],
        propertyValueParamList,
        price: parseFloat(params.price),
        mainImgUrl: imgUrlList[0].mainUrl,
        imgUrlList
      }
      try {
        const res = await request.post('/zhikuan/mn/sample/update-sample-info', editParams)
        message.success('样衣修改成功')
        onChange?.(res, editParams) // 返回创建成功的id
        setTimeout(() => {
          setVisible(false)
        }, 100)
        mes.pub('onMNEditSampleDetail')
        mes.pub('onMNEditSample')
      } catch (err) {
        console.error(err)
        message.warning(err.message)
      }
    }
  }

  const onOkSampleModal = async (processId, option) => {
    try {
      await request.post('/zhikuan/mn/sample/add-sample-info', {
        ...params,
        propertyValueParamList,
        color: [...colorList],
        mainImgUrl: imgUrlList[0].mainUrl,
        imgUrlList,
        sampleFolderId: location.pathname.startsWith('/meinian/home/sample') ? folderId : null,
        processId,
        ...option,
      })
      util.track('mn-add-sample', {
        module1: '上传样衣',
      })
      message.success('样衣新建成功')
      onChange()
      setTimeout(() => {
        setVisible(false)
      }, 100)
      mes.pub('onMNEditSampleDetail')
      mes.pub('onMNEditSample')
    } catch (err) {
      setVisible(false)
    }
  }

  const onDesignerChange = (value) => {
    setParams({
      ...params,
      designerNameList: value?.map(item => designerList.find(m => m.userId === item)).map(n => n.userName),
      designerIdList: value
    })
  }
  const onAssistantChange = (value) => {
    setParams({
      ...params,
      designerAssistantNameList: value?.map(item => designerList.find(m => m.userId === item)).map(n => n.userName),
      designerAssistantIdList: value
    })
  }

  const beforeUpload = (file) => {
    if (file.length > 10) {
      message.error('单次最多上传10张，已截取前10张图片')
      file.splice(10, file.length)
    }
    if (imgUrlList.length + file.length > 20) {
      message.error('图片数量超过20张，已截取前20张图片')
      file.splice(20 - imgUrlList.length, file.length)
    }
    return {
      files: file,
      success: true
    }
  }
  const onUpload = async (file) => {
    file.forEach((v) => {
      setimgUrlList(pre => [...pre, { mainUrl: v.url, height: v.height, width: v.width }])
    })
  }
  const deleteImg = (currentIndex) => {
    if (imgUrlList.length < 2) {
      return message.error('至少保留一张图片')
    }
    setimgUrlList(imgUrlList.filter((_, index) => index !== currentIndex))
    message.success('图片已删除')
  }
  const onDeleteSample = async () => {
    try {
      await request.get(`/zhikuan/mn/sample/delete-sample-info?sampleId=${params.id}`)
      message.success('删除成功')
      mes.pub('onMNEditSample')
      // setDeleteModel(false)
      setVisible(false)
    } catch (err) {
      console.error(err)
      message.warning(err.message)
    }
  }
  const sort = () => {
    const container = $sortWrapper.current
    if (container.length === 0) {
      return false
    }
    const sortable = new Sortable(container, {
      draggable: '.img-div',
      mirror: {
        constrainDimensions: true
      },
    })
    sortable.on('sortable:sorted', ({ data }) => {
      setSortValue({ ...data, token: new Date().getTime() })
    })
  }
  const inputNum = (value) => {
    if (!/^\d+$/.test(Number(value))) {
      return message.warning('请输入整数')
    }
    if (Math.ceil(Number(value)) > 10000000) {
      return message.warning('最多支持输入9999999')
    }
    setParams({ ...params, num: Number(value) })
  }
  const inputPrice = (value) => {
    if (Math.ceil(Number(value)) > 10000000) {
      return message.warning('最多支持输入9999999.99')
    }
    setParams({ ...params, price: value })
  }
  return <><Modal
    style={{ width: '100vw', height: '100%', borderRadius: '0' }}
    className={classNames('meinian-edit-sample')}
    visible={visible}
    hiddenCloseIcon
    hiddenFooter
  >
    <Title setVisible={setVisible} isNew={isNew} />
    <div className="content-container" ref={$container} style={{ height: getIpadVh() }}>
      <div className="sample-title-content" ref={$titleContent} style={{ left: `${(window.innerWidth - 890) / 2}px` }}>
        {
          DESIGN_TITLE.map((item, index) => {
            return <a onClick={() => onTitleChange(index)} className={classNames('title-item', { active: index === titleIndex })}>
              <span />
              <span>{item.title}</span>
            </a>
          })
        }
      </div>
      <div className="sample-info-content" ref={$screenWrapper}>
        <div className="sample-info" ref={$designContent} style={{ right: `${(window.innerWidth - 890) / 2}px` }}>
          <div className="header-placeholder" />
          <div id="sample" ref={$sample}>
            <InfoCard title="样衣图库" noBot>
              <div ref={$sortWrapper} className="img-list">
                {imgUrlList.length >= 20 ? null : <Upload
                  style={{ width: 112 }}
                  onSuccess={result => onUpload(result)}
                  multiple
                  customDir="data_infra/26/"
                  maxSize={20}
                  onBefore={beforeUpload}
                  directory={false}
                >
                  <div className="add-img">
                    <Icon type="m-tianjia" />
                    <span>添加图片</span>
                  </div>
                </Upload>}
                {imgUrlList.map((item, index) => {
                  return <div className="img-div" key={item.mainUrl} style={{ backgroundImage: `url(${ossImg(item.mainUrl, 300, 300)})` }}>
                    {index === 0 && <a className="sample-main-tag">主图</a>}
                    <a className="delete" onMouseDown={(e) => { e.stopPropagation(); deleteImg(index) }}><Icon type="m-jianshao_tianchong" /></a>
                    {index === 0 ? null : <a className="sample-main-image" onMouseDown={e => events.onChangeMainImg(imgUrlList, item, e)}> 设为主图</a>}
                  </div>
                })}
              </div>
              <i className="describe">最多可添加20张图片，拖动图片，即可调整图片在款式图库中的显示顺序</i>
            </InfoCard>
          </div>
          <div id="sample-info" ref={$sampleInfo}>
            <InfoCard title="样衣信息">
              <div className="section-item">
                <span className="label">样衣名称</span>
                <Input
                  placeholder="请输入样衣名称，最多20字，例如：牛仔短裤"
                  wrapClassName="sample-input"
                  value={params.name}
                  withBorder
                  maxLength={20}
                  onChange={(e) => {
                    if (e.target.value.length >= 21) {
                      // message.warning('最多支持输入20个字')
                      return
                    }
                    setParams({ ...params, name: e.target.value })
                  }}
                  suffix={`${params.name?.length || 0}/20`}
                />
              </div>
              {/* 样衣说明 */}
              <div className="section-item">
                <span className="label" style={{ paddingBottom: 80 }}>样衣描述</span>
                <Textarea
                  placeholder="输入内容，来让自己或其他成员更好地了解样衣的面料，辅料、工艺、风格、颜色及卖点"
                  wrapClassName="sample-textarea"
                  withBorder
                  value={params.remarks}
                  minHeight={100}
                  maxLength={200}
                  wrapStyle={{ width: '100%', paddingLeft: 16 }}
                  suffix={<div className="suffix">{`${params.remarks?.length || 0}/200`}</div>}
                  onInput={(e) => {
                    if (e.target.value.length >= 201) {
                      message.warning('最多支持输入200个字')
                      return
                    }
                    setParams({ ...params, remarks: e.target.value })
                  }}
                />
              </div>
              <div className="section-item">
                <span className="label">样衣数量</span>
                <MnInputNum
                  value={params.num}
                  onChange={inputNum}
                />
              </div>
              <div className="section-item">
                <span className="label">样衣价格</span>
                <MnInputNum
                  decimalPlaces={2}
                  value={params.price}
                  onChange={inputPrice}
                />
              </div>
              <div className="section-item">
                <span className="label">样衣尺寸</span>
                <StyleSelect placeholder="点击选择" value={params.size} options={sampleSizeData} onChange={value => setParams({ ...params, size: value })} />
              </div>
              <div className={classNames('section-item', [...colorList]?.length > 0 && 'alignment')}>
                <span className="label">样衣颜色</span>
                <TagList localKey="sampleColors" className="style-lable-tag" value={colorList} onChange={(v) => onColorsChange(v?.map(m => m.label))} suffix={20} style={{ width: '100%', marginBottom: 0 }} />
              </div>
            </InfoCard>
          </div>
          <div id="collaboration" ref={$collaboration}>
            <InfoCard title="协作成员">
              <div className="section-item">
                <span className="label">设计师</span>
                <MultipleSelect key="designer" showSearch value={params.designerIdList || []} asyncoptions={designerList?.map(m => ({ label: m.userName, value: m.userId }))} onChange={value => onDesignerChange(value)} />
              </div>
              <div className="section-item">
                <span className="label">设计助理</span>
                <MultipleSelect key="designerAssistant" value={params.designerAssistantIdList || []} asyncoptions={designerList?.map(m => ({ label: m.userName, value: m.userId }))} onChange={value => onAssistantChange(value)} />
              </div>
              <div className="section-item">
                <span className="label">打版师</span>
                <Input wrapClassName="sample-input" placeholder="请输入打版师名称" suffix={`${params.typesetter?.length || 0}/20`} value={params.typesetter} withBorder maxLength={20} onChange={e => setParams({ ...params, typesetter: e.target.value })} />
              </div>
              <div className="section-item">
                <span className="label">样衣工</span>
                <Input wrapClassName="sample-input" placeholder="请输入样衣工名称" suffix={`${params.sampleMaker?.length || 0}/20`} value={params.sampleMaker} withBorder maxLength={20} onChange={e => setParams({ ...params, sampleMaker: e.target.value })} />
              </div>

            </InfoCard>
          </div>
          <div id="sample-trait" ref={$sampleTrait}>
            <InfoCard title="款式特征">
              <div className="section-item">
                <span className="label">开款计划</span>
                <Radio.Group value={params.source || 0} onChange={e => setParams(pre => ({ ...pre, source: e.target.value }))}>
                  <Radio value={STYLE_PLAN.YUANCHUANG}>{STYLE_PLAN_TEXT[STYLE_PLAN.YUANCHUANG]}</Radio>
                  <Radio value={STYLE_PLAN.CAIMAI}>{STYLE_PLAN_TEXT[STYLE_PLAN.CAIMAI]}</Radio>
                  <Radio value={STYLE_PLAN.COOPERATION}>{STYLE_PLAN_TEXT[STYLE_PLAN.COOPERATION]}</Radio>
                  <Radio value={STYLE_PLAN.NUM}>{STYLE_PLAN_TEXT[STYLE_PLAN.NUM]}</Radio>
                </Radio.Group>
              </div>
              <div className="section-item">
                <span className="label">样衣类型</span>
                <Radio.Group value={params.type || 0} onChange={e => setParams(pre => ({ ...pre, type: e.target.value }))}>
                  <Radio value={STYLE_TYPE.BASED}>{STYLE_TYPE_TEXT[STYLE_TYPE.BASED]}</Radio>
                  <Radio value={STYLE_TYPE.THEME}>{STYLE_TYPE_TEXT[STYLE_TYPE.THEME]}</Radio>
                  <Radio value={STYLE_TYPE.FIGURE}>{STYLE_TYPE_TEXT[STYLE_TYPE.FIGURE]}</Radio>
                </Radio.Group>
              </div>
            </InfoCard>
          </div>
          <div id="sample-attribute" ref={$sampleAttribute}>
            <InfoCard
              title="样衣属性"
              // onChange={onTitleChange}
              isShowAttr
              gender={params.gender}
              accountInfo={accountInfo}
              teamInfo={teamInfo}
              setWarn={setWarn}
            >
              <div className="section-item" id="sample-gender">
                <span className="label">所属行业</span>
                <StyleSelect style={warn ? { borderColor: '#f25345' } : {}} placeholder="点击选择" value={params.gender} options={GENDER_OPTIONS} onChange={value => onGenderChange(value)} onFocus={() => setWarn(false)} />
              </div>
              {!params.gender ? <PromptMessage /> : industryLoading ? <Loading spinning wrapperClassName="spin-transparent-bg"><div style={{ height: 400 }} /></Loading> : <AttrFactory type="sample" industryAtrr={industryAtrr} value={[...propertyValueParamList]} onChange={(id, value, type) => events.onChangePropertyValue(id, value, type, name)} />}
            </InfoCard>
          </div>
          <div className="sample-associated" ref={$sampleAssociated} style={{ paddingBottom: 400 }}>
            <InfoCard title="关联信息">
              <div className="section-item">
                <span className="label">关联款式</span>
                <Input wrapClassName="sample-input" placeholder="请输入相关款式链接" value={params.relatedInspirationUrl} withBorder onChange={e => setParams({ ...params, relatedInspirationUrl: e.target.value })} />
              </div>
            </InfoCard>
          </div>
          <div className="footer-placeholder" />
        </div>
      </div>
    </div>
    <div className="modal-footer">
      {isNew ? null : <Button
        type="normal"
        className="sample-delete-btn"
        onClick={() => ModalConfirm.show({
          title: '确认删除该样衣？',
          content: '删除后不可恢复',
          onOk: onDeleteSample
        })}
      >删除</Button>}
      <div className="meinian-space" />
      <Button type="normal" onClick={() => setVisible(false)} style={{ marginRight: 16, width: 112, borderRadius: '2px' }}>取消</Button>
      <Button type="primary" style={{ width: 112, borderRadius: '2px' }} onClick={onOk}>保存</Button>
    </div>
  </Modal>
    {sampleVisible && <SampleModal
      visible={sampleVisible}
      onClose={() => setSampleVisible(false)}
      trackSourceType
      onOk={onOkSampleModal}
    />}
  </>
}

const InfoCard = (props) => {
  const { title, introduce, gender, isShowAttr, accountInfo, teamInfo, onChange, setWarn, noBot } = props
  const onChangeGener = () => {
    onChange && onChange(1)
    setWarn && setWarn(true)
  }
  return <div className="info-card">
    <div className="card-title" style={{ marginBottom: noBot ? 0 : 16 }}>
      <div className="title-left">
        <div className="sample-title">{title}</div>
        <div className="introduce">{introduce}</div>
      </div>
      {isShowAttr && <div className="title-right">
        <a className="current-gender" onClick={onChangeGener}>
          <span>当前行业</span>
          <span>{gender}</span>
          <Icon type="m-bianji" />
        </a>
        <div className="custom-attr">
          <UserDefinedProps gender={gender} accountInfo={accountInfo} teamInfo={teamInfo} type={2} />
        </div>
      </div>}
    </div>
    {props.children}
  </div>
}

const PromptMessage = () => {
  return <div className="prompt-meg">
    <Icon type="m-zhuyi_tianchong" />
    <span>请先选择行业后，填写相关样衣属性</span>
  </div>
}
